import React, {type FC} from 'react';
import {useGlobals, withGlobals} from '../../../../../globalPropsContext';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {Experiments} from '../../../../../constants';
import {Clear} from '@wix/wix-ui-icons-common/on-stage';
import {TextButton} from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import s from './ClearFiltersButton.scss';
import {classes, st} from './ClearFiltersButton.st.css';

export const ClearFiltersButtonDataHooks = {
  Button: 'clear-filters-button',
  X: 'clear-filters-button-x',
  CategoriesButton: 'categories-clear-filters-button',
};

export interface IClearFiltersButtonProps extends IProvidedTranslationProps {
  onClearFilters: Function;
}

const ClearFiltersButtonComp: FC<IClearFiltersButtonProps> = ({t, onClearFilters}) => {
  const {hasSelectedFilters, shouldShowMobile, usingExtendedGridGalleryStyles, useExperiments} = useGlobals();
  const isNewClearFiltersHoverStateEnabled = useExperiments.enabled(Experiments.NewClearFiltersHoverState);

  return usingExtendedGridGalleryStyles ? (
    <TextButton
      disabled={!hasSelectedFilters}
      data-hook={ClearFiltersButtonDataHooks.CategoriesButton}
      onClick={() => onClearFilters()}
      className={classNames(
        s.clearFiltersButton,
        {
          [s.usingExtendedGridGalleryStyles]: usingExtendedGridGalleryStyles,
          [s.oldHoverBehavior]: !isNewClearFiltersHoverStateEnabled,
          [s.newHoverBehavior]: isNewClearFiltersHoverStateEnabled,
        },
        st(classes.textButtonRoot, {useMobileColor: shouldShowMobile})
      )}
      priority={'secondary' as any}
      suffixIcon={!shouldShowMobile && <Clear />}>
      {t('clearFiltersButtonText')}
    </TextButton>
  ) : (
    <button
      type="button"
      data-hook={ClearFiltersButtonDataHooks.Button}
      onClick={() => onClearFilters()}
      className={classNames(s.clearFiltersButton, {
        [s.disabled]: !hasSelectedFilters,
        [s.oldHoverBehavior]: !isNewClearFiltersHoverStateEnabled,
        [s.newHoverBehavior]: isNewClearFiltersHoverStateEnabled,
      })}>
      {t('clearFiltersButtonText')}
      {!shouldShowMobile && (
        <span className={s.clearFiltersX} data-hook={ClearFiltersButtonDataHooks.X}>
          X
        </span>
      )}
    </button>
  );
};

export const ClearFiltersButton = withGlobals(withTranslations()(ClearFiltersButtonComp));
